'use client';

import Button from '@/components/ui/Button';
import Image from 'next/image';
import Link from 'next/link';

const MediaPartnersSection = () => {
  const partners = [
    {
      alt: "CryptoNewsZ-Logo",
      src: "/images/cryptonews.svg",
      link: "https://www.cryptonewsz.com/",
    },
    {
      alt: "times-of-blockchain.svg",
      src: "/images/times-of-blockchain.svg",
      link: "https://www.timesofblockchain.com/",
    },
    
    {
      alt: "namecoinnews",
      src: "/images/namecoinnews.svg",
      link: "https://www.namecoinnews.com/",
    },
    {
      alt: "timesofai",
      src: "/images/timesofai.svg",
      link: "https://www.timesofai.com/",
    },
    {
      alt: "Cryptomoonpress",
      src: "/images/cryptomoonpress.svg",
      link: "https://cryptomoonpress.com/",
    },
    {
      alt: "capitalbay-news",
      src: "/images/capitalbay-news.webp",
      link: "https://www.capitalbay.news/",
    },
    {
      alt: "Coinnewsspan",
      src: "/images/coinnewsspan-new.svg",
      link: "https://www.coinnewsspan.com/",
    },
    {
      src: "/images/all-conference-alert.webp",
      alt: "allconferencealert",
      link: "https://allconferencealert.net/",
    },
    {
      src: "/images/cryptojist-black-transparent.webp",
      alt: "cryptojist-black-transparent",
      link: "https://cryptojist.com/",
    },
    {
      src: "/images/gtm-labs-logo.webp",
      alt: "gtm-labs-logo",
      link: "https://gtmlabs.xyz/",
    },
    {
      src: "/images/aI-time-journal-logo.webp",
      alt: "AI-Time-Journal-Logo",
      link: "https://www.aitimejournal.com/",
    },
    {
      src: "/images/coin-gabbar.webp",
      alt: "coin-gabbar",
      link: "http://www.coingabbar.com/",
    },
    {
      src: "/images/cryptopolitan.webp",
      alt: "Cryptopolitan",
      link: "https://www.cryptopolitan.com/",
    },
    {
      src: "/images/3vsersetv.webp",
      alt: "3vsersetv",
      link: "https://www.3versetv.com/",
    },
    {
      src: "/images/cryptoken-media-logo.webp",
      alt: "cryptoken-media-logo",
      link: "https://cryptoken.media",
    },
    {
      src: "/images/web3wire-logo.webp",
      alt: "web3wire-logo",
      link: "https://web3wire.org/",
    },
    {
      src: "/images/cio-review.webp",
      alt: "cio-review",
      link: "https://www.cioreview.com/",
    },
    {
      src: "/images/wikibit-logo.webp",
      alt: "wikibit-logo",
      link: "https://www.wikiexpo.com",
    },
    {
      src: "/images/financial-servicesreview.webp",
      alt: "financial-servicesreview",
      link: "https://www.financialservicesreview.com/",
    },
     {
      src: "/images/transport-stake.webp",
      alt: "Financial-transport-stake",
      link: "https://www.transportstake.com/",
    },
     {
      src: "/images/smarttechmoney.webp",
      alt: "smarttechmoney",
      link: "https://www.smartmoneymatch.com/",
    },
     {
      src: "/images/publicitymarketplace-logo.webp",
      alt: "publicitymarketplace-logo",
      link: "https://www.publicitymarketplace.com/",
    },
     {
      src: "/images/functionalsourcing.webp",
      alt: "functionalsourcing",
      link: "https://www.functionalsourcing.com/",
    },
     {
      src: "/images/education-stake-logo.webp",
      alt: "education-stake-logo",
      link: "https://www.educationstake.com/",
    },
     {
      src: "/images/match-sdg-logo.webp",
      alt: "match-sdg-logo",
      link: "https://www.matchsdg.com/",
    },
     {
      src: "/images/alhuda.webp",
      alt: "alhuda",
      link: "https://www.alhudacibe.com/",
    },
     {
      src: "/images/btc-wire.webp",
      alt: "btc-wire",
      link: "https://btcwire.io/",
    },
    {
      src: "/images/conlytix-logo.webp",
      alt: "coinlytx",
      link: "https://coinlytx.com/",
    },
    {
      src: "/images/coinscapture-logo.webp",
      alt: "coinscapture",
      link: "https://coinscapture.com/",
    },
    {
      src: "/images/vitaminai-logo.webp",
      alt: "coinscapture",
      link: "https://vitaminai.online/",
    },
    {
      src: "/images/huidu-light-background.webp",
      alt: "huidu",
      link: "#",
    },
    {
      src: "/images/blockchain-reporter.webp",
      alt: "blockchain-reporter",
      link: "https://blockchainreporter.net/",
    },
    {
      src: "/images/techtokens-logo.webp",
      alt: "Techtokens-Logo",
      link: "https://techtoken.in/",
    },
    {
      src: "/images/cryptobrowser.webp",
      alt: "cryptobrowser",
      link: "https://cryptobrowser.io/",
    },
    {
      src: "/images/zexprwire-logo.webp",
      alt: "zexprwire-logo",
      link: "https://zexprwire.com/",
    },
    {
      src: "/images/cointopper.webp",
      alt: "cointopper",
      link: "https://cointopper.com/",
    },
    {
      src: "/images/ai-pressroom-logo.webp",
      alt: "aipressroom",
      link: "https://aipressroom.com/",
    },
    {
      src: "/images/gogetgpt-logo.svg",
      alt: "gogetgpt-logo",
      link: "https://gogetgpt.com/",
    },
    {
      src: "/images/voice-of-crypto.webp",
      alt: "voiceofcrypto",
      link: "https://voiceofcrypto.online/",
    },
     {
      src: "/images/droomdroom-black.webp",
      alt: "droomdroom-black",
      link: "https://droomdroom.com/",
    },
    {
      src: "/images/cfeablack.webp",
      alt: "Cfeablack",
      link: "https://coinfea.com/",
    },
    {
      src: "/images/coinworldstory-logo.webp",
      alt: "coinworldstory-logo",
      link: "https://coinworldstory.com/",
    },{
      src: "/images/coinroop.webp",
      alt: "coinroop",
      link: "https://coinroop.com/",
    },{
      src: "/images/coinzoba-logo.webp",
      alt: "coinzoba-logo",
      link: "https://coinzoba.com/",
    },{
      src: "/images/logo-coinkimona-logo.webp",
      alt: "logo-coinkimona-logo",
      link: "https://coinkimona.com/",
    },{
      src: "/images/lixwe.webp",
      alt: "LIXWE",
      link: "https://lixwe.com/",
    },{
      src: "/images/altwow.webp",
      alt: "altwow",
      link: "https://altwow.com/",
    },{
      src: "/images/propfirm-lion.webp",
      alt: "propfirm-lion",
      link: "https://propfirmlion.com/",
    },{
      src: "/images/coinhohe.webp",
      alt: "coinhohe",
      link: "https://coinhohe.com/",
    },{
      src: "/images/triplolo-logo.webp",
      alt: "triplolo-logo",
      link: "https://triplolo.com/",
    },{
      src: "/images/aistoryland-logo.webp",
      alt: "aistoryland-logo",
      link: "https://aistoryland.com/",
    },
    {
      src: "/images/coinaute.webp",
      alt: "coinaute",
      link: "https://coinaute.com/",
    },
    {
      src: "/images/corum8-black-logo.svg",
      alt: "Corum8Black-Logo",
      link: "https://corum8.com/",
    },
     {
      src: "/images/publicity-marketplace.webp",
      alt: "publicity-marketplace",
      link: "https://www.publicitymarketplace.com/",
    },
    {
      src: "/images/cryptosnewss.webp",
      alt: "CryptosNewss",
      link: "https://cryptosnewss.com/",
    },
    {
      src: "/images/bitcoin-world-logo-golden.webp",
      alt: "bitcoin-world-logo-golden",
      link: "https://bitcoinworld.co.in/",
    },
    {
      src: "/images/edarabia-logo.webp",
      alt: "edarabia-logo",
      link: "https://www.edarabia.com/",
    },
    {
      src: "/images/coingape.webp",
      alt: "coingape",
      link: "https://coingape.com/",
    },
    {
      src: "/images/coin-edition.webp",
      alt: "coinedition",
      link: "https://coinedition.com/",
    },
    {
      src: "/images/ymm-logo.webp",
      alt: "yourmindmedia",
      link: "https://yourmindmedia.com/",
    },
    {
      src: "/images/startupnews-logo.webp",
      alt: "startupnews",
      link: "https://startupnews.fyi/",
    },
    {
      src: "/images/expo-tobi-logo.webp",
      alt: "ExpoTobiLogo",
      link: "",
    },
    {
    alt: "tmp-logo",
    src: "/images/tmp-logo.webp",
    width: 170,
    height: 140,
    link: "https://themarketperiodical.com/",
  },
  {
    alt: "the-coin-republic",
    src: "/images/the-coin-republic.webp",
    width: 170,
    height: 140,
    link: "https://www.thecoinrepublic.com/",
  },
  {
    alt: "embassyofbitcoin",
    src: "/images/embassyofbitcoin.webp",
    width: 170,
    height: 140,
    link: "https://www.embassyofbitcoin.com/",
  },{
    alt: "kd-wire-black",
    src: "/images/kd-wire-black.webp",
    width: 170,
    height: 140,
    link: "https://keydifference.com/wire/",
  },
  {
    alt: "web3africa",
    src: "/images/web3africa.webp",
    width: 170,
    height: 140,
    link: "https://web3africa.tech/",
  },
  {
    alt: "indewswire-logo",
    src: "/images/indewswire-logo.webp",
    width: 170,
    height: 140,
    link: "https://indnewswire.com/",
  },
  {
    alt: "affmaven-logo",
    src: "/images/affmaven-logo.webp",
    width: 170,
    height: 140,
    link: "https://affmaven.com/",
  },
  {
    alt: "cryptonews",
    src: "/images/crypto-news-logo-full.svg",
    width: 170,
    height: 140,
    link: "https://cryptonews.com/",
  },
  {
    alt: "blockchainreporter",
    src: "/images/blockchainreporter.webp",
    width: 170,
    height: 140,
    link: "https://blockchainreporter.net/",
  },
  {
    alt: "coin-pedia",
    src: "/images/coin-pedia.webp",
    width: 170,
    height: 140,
    link: "https://coinpedia.org/",
  },
  {
    alt: "dubai-global-news",
    src: "/images/dubai-global-logo.webp",
    width: 170,
    height: 140,
    link: "https://www.dubaiglobalnews.com/",
  },
  {
    src: '/images/web3africa.webp',
    alt: 'web3africa',
    width: 170,
    height: 140,
    link: 'https://web3africa.tech/',
  },
  
  {
    src: '/images/theblockopedia-new.webp',
    alt: 'web3africa',
    width: 170,
    height: 140,
    link: 'https://theblockopedia.com/',
  },
  

];



  return (
    <section data-component-id="src/app/MediaPartnersSection.tsx:409:4" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="409" data-component-end-line="462" data-component-file="MediaPartnersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22media-partners%22%2C%22className%22%3A%22w-full%20py-10%22%7D" id="media-partners" className="w-full py-10">
      <div data-component-id="src/app/MediaPartnersSection.tsx:410:6" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="410" data-component-end-line="441" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1342px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="max-w-[1342px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Heading */}
        <div data-component-id="src/app/MediaPartnersSection.tsx:412:8" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="412" data-component-end-line="418" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20mb-6%20pb-10%22%7D" className="flex justify-center mb-6 pb-10">
          <div data-component-id="src/app/MediaPartnersSection.tsx:413:10" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="413" data-component-end-line="417" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-2%20items-center%20bg-%5B%231d1d1d%5D%20rounded-%5B12px%5D%20px-4%20py-2%22%7D" className="flex gap-2 items-center bg-[#1d1d1d] rounded-[12px] px-4 py-2">
            <div data-component-id="src/app/MediaPartnersSection.tsx:414:12" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="414" data-component-end-line="414" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-2%20h-2%20bg-%5B%2327a6b8%5D%20rounded-sm%22%7D" className="w-2 h-2 bg-[#27a6b8] rounded-sm" />
            <h2 data-component-id="src/app/MediaPartnersSection.tsx:415:12" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="415" data-component-end-line="415" data-component-file="MediaPartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-white%20text-base%20sm%3Atext-lg%20lg%3Atext-xl%22%2C%22textContent%22%3A%22Past%20Media%20Partners%22%7D" className="text-white text-base sm:text-lg lg:text-xl">Past Media Partners</h2>
            <div data-component-id="src/app/MediaPartnersSection.tsx:416:12" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="416" data-component-end-line="416" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-2%20h-2%20bg-%5B%2327a6b8%5D%20rounded-sm%22%7D" className="w-2 h-2 bg-[#27a6b8] rounded-sm" />
          </div>
        </div>

        {/* Logos Grid */}
        <div data-component-id="src/app/MediaPartnersSection.tsx:421:8" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="421" data-component-end-line="440" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-4%20lg%3Agrid-cols-6%20gap-4%20sm%3Agap-6%20justify-items-center%20items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 sm:gap-6 justify-items-center items-center">
          {partners.map((partner, index) => (
            <a data-component-id="src/app/MediaPartnersSection.tsx:423:12" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="423" data-component-end-line="438" data-component-file="MediaPartnersSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22hover%3Aopacity-80%20transition-opacity%22%7D"
              key={index}
              href={partner.link}
              target="_blank"
              rel={index === 0 ? "noopener noreferrer" : "noopener noreferrer nofollow"}
              className="hover:opacity-80 transition-opacity"
            >
              <Image data-component-id="src/app/MediaPartnersSection.tsx:430:14" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="430" data-component-end-line="437" data-component-file="MediaPartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20w-%5B230px%5D%20h-%5B70px%5D%20bg-white%20p-2%20rounded-lg%22%7D"
                src={partner.src}
                alt={partner.alt}
                width={140}
                height={70}
                className="object-contain w-[230px] h-[70px] bg-white p-2 rounded-lg"
                unoptimized
              />
            </a>
          ))}
        </div>
      </div>

      {/* CTA Button */}
      <div data-component-id="src/app/MediaPartnersSection.tsx:444:6" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="444" data-component-end-line="461" data-component-file="MediaPartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20gap-4%20mt-%5B47px%5D%20sm%3Amt-%5B70px%5D%20lg%3Amt-%5B94px%5D%20text-center%22%7D" className="flex flex-col items-center gap-4 mt-[47px] sm:mt-[70px] lg:mt-[94px] text-center">
        <h2 data-component-id="src/app/MediaPartnersSection.tsx:445:8" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="445" data-component-end-line="447" data-component-file="MediaPartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B%2327a6b8%5D%20text-%5B28px%5D%20sm%3Atext-%5B34px%5D%20lg%3Atext-%5B40px%5D%20font-bold%20leading-tight%22%2C%22textContent%22%3A%22Join%20the%20CliniConnect%22%7D" className="text-[#27a6b8] text-[28px] sm:text-[34px] lg:text-[40px] font-bold leading-tight">
          Join the CliniConnect
        </h2>
        <Link data-component-id="src/app/MediaPartnersSection.tsx:448:8" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="448" data-component-end-line="460" data-component-file="MediaPartnersSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22https%3A%2F%2Fluma.com%2Fcalendar%2Fcal-M5IWE20m6nKfap1%22%7D" href="https://luma.com/calendar/cal-M5IWE20m6nKfap1">
          <Button data-component-id="src/app/MediaPartnersSection.tsx:449:10" data-component-path="src/app/MediaPartnersSection.tsx" data-component-line="449" data-component-end-line="459" data-component-file="MediaPartnersSection.tsx" data-component-name="Button" data-component-content="%7B%22elementName%22%3A%22Button%22%2C%22className%22%3A%22px-8%20py-4%20text-center%20mx-auto%20hover%3Abg-%5B%2326a3b6%5D%20transition-all%20duration-200%22%7D"
            text="Subscribe to our Event Calendar"
            text_font_size="text-xl"
            text_font_family="Helvetica Neue"
            text_font_weight="font-medium"
            text_line_height="leading-lg"
            text_color="text-white"
            border_border_radius="rounded-[34px]"
            fill_background_color="#27a6b8"
            className="px-8 py-4 text-center mx-auto hover:bg-[#26a3b6] transition-all duration-200"
          />
        </Link>
      </div>
    </section>
  );
};

export default MediaPartnersSection;
